<div class="top">
    <div class="container">
        <div class="row">
            <div class="col-md-6 mx-auto">
                <h2 align="center" style="margin-top: 50px;margin-bottom: 20px;">Login</h2>
                <form class="example-form" [formGroup]="form" (ngSubmit)="submit()">
                    <mat-form-field class="example-full-width border-white" color="warn">
                        <mat-label>Email</mat-label>
                        <input matInput placeholder="  Email id" formControlName="email" id="email"
                            [(ngModel)]="email" type="text" required maxlength="40"/>
                        <span matPrefix></span>
                        <mat-error *ngIf="f.email.errors?.email && !f.email.errors?.required">
                            Please enter a valid email address
                        </mat-error>
                        <mat-error *ngIf="f.email.errors?.required">
                            Email is <strong>required</strong>
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field class="example-full-width" color="warn">
                        <mat-label>Password</mat-label>
                        <input matInput placeholder="Password" formControlName="password" id="password"
                            [(ngModel)]="password" [type]="hide ? 'password' : 'text'" required maxlength="40"/>
                        <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
                            [attr.aria-pressed]="hide">
                            <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                        </button>
                        <mat-error *ngIf="f.password.errors?.required">
                            Password is <strong>required</strong>
                        </mat-error>
                    </mat-form-field>
                    <div class="float-right"><a [routerLink]="['forgot']" style="color: black;">Forgot password
                            ?</a></div>
                    <br><br>
                    <p style="color: red;" align="center">{{Message}}</p>
                    <div class="center">
                        <button mat-raised-button color="dark" class="btn button-style float-none" type="submit"
                            style="margin-top: 50px;">Login</button>
    
                    </div>
                    <!-- <div class="center">
                        <button mat-raised-button color="dark" class="btn button-style float-none"
                            style="margin-top: 50px;" (click)="toggleShow()">Login</button>
    
                    </div> -->
                    <div style="margin-top: 20px;">
                        <main class="questionNumbers">
                            <div class="questionNumberLine"></div>
                            <div class="questionNumberIcon">
                                OR
                            </div>
                            <div class="questionNumberLine"></div>
                        </main>
    
                    </div>
                </form>
                <form class="example-form">
                    <div class="center">
                        <button mat-raised-button color="dark" class="btn1 button-style float-none"
                            style="margin-top: 30px;" (click)="signInWithGoogle()"><img src="assets\Images\g_b.jpg" width="30" style="margin-right: 10px;">Sign in with
                            Gmail</button>
                            <!-- C:\Users\Renee Systems\Desktop\Projects\MTL-Projects\descartweb\src\assets\Images\g_b.jpg -->
    
                    </div>
                </form>
    
                <div id="hidest">
                    <p style="margin: 15px;text-align: center;"><a [routerLink]="[]" (click)="toggleShow()"
                            style="color: grey;">
                            Create new Account
                            <svg width="2em" height="1em" viewBox="0 0 16 16" class="bi bi-arrow-right"
                                fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd"
                                    d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z" />
                            </svg></a></p>
                </div>
            </div>
        </div>
    </div>
</div>
